/**
 * Stroke-style icons for the milestone progress bars, ported from the
 * CAX-3160 design handoff. All inherit `currentColor` so the milestone
 * node controls their color. The castle is original brand-safe artwork
 * (not the licensed Disney mark).
 */

interface IconProps {
  className?: string
}

export function CastleIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth={1.6}
      strokeLinecap='round'
      strokeLinejoin='round'
      aria-hidden='true'
    >
      <path d='M3 20.4h18' />
      <path d='M4.6 20.4V11.2h3.4v9.2' />
      <path d='M4 11.2 6.3 8.4 8.6 11.2' />
      <path d='M6.3 8.4V6.3' />
      <path d='M6.3 6.3 8 6.8 6.3 7.4' />
      <path d='M16 20.4V11.2h3.4v9.2' />
      <path d='M15.4 11.2 17.7 8.4 20 11.2' />
      <path d='M17.7 8.4V6.3' />
      <path d='M17.7 6.3 19.4 6.8 17.7 7.4' />
      <path d='M9.4 20.4V9.2h5.2v11.2' />
      <path d='M8.8 9.2 12 5.2 15.2 9.2' />
      <path d='M12 5.2V2.9' />
      <path d='M12 2.9 14 3.5 12 4.2' />
      <path d='M10.7 20.4v-3.1a1.3 1.3 0 0 1 2.6 0v3.1' />
    </svg>
  )
}